import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import LeftCont from "../../../components/pc/component/LeftCont";
import DatePicker from "react-datepicker";
import { registerLocale } from  "react-datepicker";
import ko from 'date-fns/locale/ko';
import { enum_api_uri, enum_de_status, enum_mo_title,enum_sell_kind} from "../../../config/enum";
import Pagination from "../../../components/pc/component/Pagination";
import { detailPageBack, moTitle } from "../../../store/commonSlice";
import { proDetailPop } from "../../../store/popupSlice";
import moment from "moment";
import { isBrowser, isMobile } from "react-device-detect";
import * as CF from "../../../components/pc/component/Function";
import InputDatepicker from "../../../components/pc/component/InputDatepicker";

const OnlineCheck = (props) => {
    //왼쪽메뉴 토글
    let toggle = localStorage.getItem("menuToggle");
    const [contFold, setContFold] = useState(toggle);

    useEffect(()=>{
        setContFold(contFold);
    },[contFold]);
    
    const [invoiceList, setInvoiceList] = useState([]);
    const p_list_invoice = enum_api_uri.p_list_invoice;
    registerLocale('ko', ko);
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const common = useSelector((state)=>state.common);
    const basicDate = new Date();
    const [ipDateStart, setIpDateStart] = useState('');
    const [ipDateEnd, setIpDateEnd] = useState('');
    const [ipStatus, setIpStatus] = useState('');
    const [dateError, setDateError] = useState(false);
    const [page_no, setPageNo] = useState(1);
    const perPage = 10;//페이지당 리스트수 
    const [totalCount, setTotalCount] = useState(0);
    const [viewPaging, setPaging] = useState(0);
    const location = useLocation();
    const [scrollMove, setScrollMove] = useState(false);

    //모바일일때 헤더타이틀 변경
    useEffect(()=>{
        if(isMobile){
            let tit = enum_mo_title[location.pathname];
            dispatch(moTitle(tit));
        }
    },[]);

    //상세->목록으로 뒤로가기시 저장되었던 스크롤위치로 이동
    useEffect(()=>{
        setScrollMove(scrollMove);
        
        if(scrollMove){
            let ScrollY = sessionStorage.getItem("ScrollY");
            window.scrollTo(0,ScrollY); 
        }
    },[scrollMove]);

    useEffect(()=>{
        setIpStatus(ipStatus);
    },[ipStatus]);

    useEffect(()=>{
        setIpDateStart(ipDateStart);
    },[ipDateStart]);

    useEffect(()=>{
        setIpDateEnd(ipDateEnd);
    },[ipDateEnd]);

    const dStartChange = (date) => {
        setIpDateStart(date);
        setDateError(false);
    };

    const dEndChange = (date) => {
        setIpDateEnd(date);
        setDateError(false);
    };

    useEffect(()=>{
        setInvoiceList(invoiceList);
    },[invoiceList]);

    useEffect(() => {
        setTotalCount(totalCount);
    },[totalCount]);

    useEffect(() => {
        setPaging(viewPaging);
    },[viewPaging]);

    useEffect(()=>{ //처음 한번 리스트 불러오기a1

        console.log(common.detailPageBack);

        // 상세페이지에서 뒤로가기클릭시 저장된 정보로 리스트불러오기
        if(common.detailPageBack === true){
            dispatch(detailPageBack(false));

            let listPage = JSON.parse(sessionStorage.getItem("listPage"));
            let pageNum = sessionStorage.getItem("pageNum");

            let val = [];
            val.ip_status = listPage.ip_status;
            val.ip_date_start = listPage.ip_date_start;
            val.ip_date_end = listPage.ip_date_end;
            val.page_no_now = pageNum;
            val.record_size = 10;

            let startDate = moment(listPage.ip_date_start).toISOString();
            startDate = new Date(startDate);
            let endDate = moment(listPage.ip_date_end).toISOString();
            endDate = new Date(endDate);

            setIpDateStart(startDate);
            setIpDateEnd(endDate);
            setIpStatus(listPage.ip_status);
            setPageNo(pageNum);
            getList(val);
        }
        if(common.detailPageBack === false){
            let val = [];
            val.ip_status = '';
            val.ip_date_start  = moment(basicDate).format('YYYYMMDD');
            val.ip_date_end  = moment(basicDate).format('YYYYMMDD');
            val.page_no_now = 1
            val.record_size = 10

            setIpDateStart(basicDate)
            setIpDateEnd(basicDate)
            setPageNo(1);
            getList(val);

            //리스트페이지 조회 데이터저장
            let listPageData = {
                ip_status:'',
                ip_date_start: moment(basicDate).format('YYYYMMDD'),
                ip_date_end: moment(basicDate).format('YYYYMMDD')
            };
            CF.setListPage(listPageData);
            CF.setPageNum(1);
        }
    },[]);

    //온라인거래결과 조회
    const submit = (values) => {
        let regex = /[^0-9]/g;
        let ip_status = ipStatus.replace(regex,'');
        let ip_date_start = moment(ipDateStart).format('YYYYMMDD');
        let ip_date_end = moment(ipDateEnd).format('YYYYMMDD');

        let val = [];
        val.ip_status = ip_status;
        val.ip_date_start = ip_date_start;
        val.ip_date_end = ip_date_end;
        val.page_no_now = 1;
        val.record_size = 10;
        setPageNo(1);
        getList(val); //리스트 받아오기

        //리스트페이지 조회 데이터저장
        let listPageData = {
            ip_status:ip_status,
            ip_date_start:ip_date_start,
            ip_date_end:ip_date_end
        };
        CF.setListPage(listPageData);
        CF.setPageNum(1);
    };

    //페이징 숫자 클릭시
    const moveToPage = (goPage) => {
        //console.log('moveToPage:'+goPage);
        let val = [];
        val.ip_status = ipStatus;
        val.ip_date_start = moment(ipDateStart).format('YYYYMMDD');
        val.ip_date_end = moment(ipDateEnd).format('YYYYMMDD');
        val.page_no_now = goPage; //움직일 페이지
        val.record_size = 10;
        setPageNo(goPage);
        getList(val); //리스트 받아오기

        //리스트페이지 페이징숫자 저장
        CF.setPageNum(goPage);
    };

    const getList = (val) => {
        axios.get(`${p_list_invoice}?ip_date_start=${val.ip_date_start}&ip_date_end=${val.ip_date_end}&ip_status=${val.ip_status}&record_size=${val.record_size}&page_no=${val.page_no_now}`,
            {headers:{Authorization: `Bearer ${token}`}}
        )
        .then((res)=>{
            if(res.status === 200){
                // console.log(res);
                let data = res.data;
                let state = [...data.results];
                let resCount = data.total_record_count;
                setInvoiceList(state);//리스트 생성
                setTotalCount(resCount); // 검색결과 전체 건수 컨트롤
                setPaging(resCount); //페이징 컨트롤

                if(common.detailPageBack){
                    setScrollMove(true);
                }
            }
        })
        .catch((error) => {
            console.log(error);
        });
    };

    return (<>
        {/* PC일때 */}
        {isBrowser &&
            <div className="page_sub">
                <div className={`cont cont_wrap ${contFold === "true" && "fold"}`}>
                    <LeftCont user={props.user} contFold={contFold} setContFold={setContFold}/>
                    <div className="right_cont">
                        <div className="inner_box">
                            <div className="top_tit">
                                <p className="tit">입하 및 경매/입찰결과 조회</p>
                                <ul className="menu_list">
                                    <li>홈</li>
                                    <li>출하자</li>
                                    <li>입하 및 온라인거래결과 조회</li>
                                </ul>
                            </div>
                            <Formik
                                initialValues={{
                                    // ip_status: ipStatus || "",
                                }}
                                onSubmit={submit}
                                validateOnMount={true}
                            >
                                {({values, setFieldValue, handleSubmit, handleChange, handleBlur, errors, touched}) => (
                                    <form onSubmit={handleSubmit}>
                                        <ul className="search_box">
                                            <li>
                                                <p className="txt">출하일자</p>
                                                <div className="date_input">
                                                    <InputDatepicker selectedDate={ipDateStart} ChangeHandler={dStartChange} />
                                                    <InputDatepicker selectedDate={ipDateEnd} ChangeHandler={dEndChange} />
                                                </div>
                                            </li>
                                            <li>
                                                <p className="txt">상태</p>
                                                <div className="clearfix">
                                                    <div className="custom_select rm5">
                                                        <select 
                                                            value={`ip_status_${ipStatus}`}
                                                            onChange={(e)=>{
                                                                let value = e.currentTarget.value;
                                                                    value = value.replace(/[^0-9]/g,'');
                                                                setIpStatus(value);
                                                            }}
                                                            style={{ display: 'block' }}
                                                        >
                                                            <option value="">전체</option>
                                                            <option value="ip_status_1">입하</option>
                                                            <option value="ip_status_2">입하승인</option>
                                                            <option value="ip_status_3">입하미승인</option>
                                                        </select>
                                                    </div>
                                                    <button className="btn_s" type="submit">조회</button>
                                                </div>
                                            </li>
                                        </ul>
                                        {dateError && 
                                            <div className="alert_txt f_12">출하일자를 선택해주세요.</div>
                                        }
                                        <div className="tm30">
                                            <p className="medium bp20">검색 결과 : <span className="txt_sky">{totalCount}</span>건</p>
                                            {invoiceList.length == 0 && <div className="none_data"><span>데이터가 없습니다.</span></div>}
                                            {invoiceList.length > 0 && invoiceList.map((a,i)=>{
                                                let sumQuantity = 0;
                                                let sumPrice = 0;
                                                let ip_auct_name = invoiceList[i].ip_auct_name;
                                                let ip_auct_date_start = invoiceList[i].ip_auct_date_start;
                                                let ip_auct_date_end = invoiceList[i].ip_auct_date_end;
                                                let inKind = enum_sell_kind[a.ip_s_kind.trim()];
                                                

                                                return(
                                                    <div className="bp30" key={i}>
                                                       <p className="table_gray_txt bp10">
                                                                {inKind}
                                                                <span>등록번호: {`${invoiceList[i].ip_date_online}-${invoiceList[i].ip_no_online}`}</span>
                                                                {ip_auct_name !== null && ip_auct_name.trim().length > 0 &&
                                                                    <span>경매사 : {ip_auct_name}</span>
                                                                }
                                                                {ip_auct_date_start !== null && ip_auct_date_start.trim().length > 0 &&
                                                                    <span>{inKind}시간 : {CF.MDFWithHour(ip_auct_date_start,2)}
                                                                        {ip_auct_date_end !== null && ip_auct_date_end.trim().length > 0 &&
                                                                            "~"+CF.MDFWithHour(ip_auct_date_end,2)
                                                                        }
                                                                    </span>
                                                                }
                                                        </p>
                                                        <div className="custom_table">
                                                            {invoiceList[i].detltrns && invoiceList[i].detltrns.length > 0 ? (
                                                                <table>
                                                                    <colgroup>
                                                                        <col style={{width:'50px'}} />
                                                                        <col style={{width:'auto'}} />
                                                                        <col style={{width:'auto'}} />
                                                                        <col style={{width:'100px'}} />
                                                                        <col style={{width:'150px'}} />
                                                                        <col style={{width:'150px'}} />
                                                                        <col style={{width:'70px'}} />
                                                                    </colgroup>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>번호</th>
                                                                            <th>생산자</th>
                                                                            <th>품목명</th>
                                                                            <th>수량</th>
                                                                            <th>판매금액</th>
                                                                            <th>상태</th>
                                                                            <th>보기</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {invoiceList[i].detltrns.map((a,idx) => {
                                                                            let de_price = invoiceList[i].detltrns[idx].de_quantity * invoiceList[i].detltrns[idx].de_price1;
                                                                            de_price =  CF.MakeIntComma(de_price);
                                                                            let de_quantity = CF.MakeIntComma(invoiceList[i].detltrns[idx].de_quantity);

                                                                            sumQuantity = sumQuantity + invoiceList[i].detltrns[idx].de_quantity;
                                                                            sumPrice = sumPrice + invoiceList[i].detltrns[idx].de_quantity * invoiceList[i].detltrns[idx].de_price1;
                                                                            
                                                                            //상태
                                                                            let status = invoiceList[i].detltrns[idx].de_status.trim();
                                                                                status = enum_de_status[status][0];

                                                                            let de_farm_name = CF.objValueTrim(invoiceList[i].detltrns[idx].de_farm_name);

                                                                            return(
                                                                                <tr key={idx}>
                                                                                    <td>{idx+1}</td>
                                                                                    <td>{de_farm_name}</td>
                                                                                    <td>
                                                                                        <Link 
                                                                                            to={`/shipper/online-check/detail/${invoiceList[i].detltrns[idx].de_ip_date}-${invoiceList[i].detltrns[idx].de_ip_no}`} 
                                                                                            onClick={()=>{
                                                                                                //리스트페이지 현재스크롤위치 저장
                                                                                                CF.setScrollY(window.scrollY);
                                                                                            }}
                                                                                        >
                                                                                            <div className="over_txt"><span>{invoiceList[i].detltrns[idx].gm_name}</span></div>
                                                                                        </Link>
                                                                                    </td>
                                                                                    <td className="tx_r">{de_quantity}개</td>
                                                                                    <td className="tx_r">{de_price}원</td>
                                                                                    <td>{status} 
                                                                                        {invoiceList[i].detltrns[idx].de_status.trim() == 14 ?
                                                                                            <Link 
                                                                                                to={`/shipper/online-check/detail/${invoiceList[i].detltrns[idx].de_ip_date}-${invoiceList[i].detltrns[idx].de_ip_no}`} 
                                                                                                className="btn2_s2 tm3"
                                                                                                onClick={()=>{
                                                                                                    //리스트페이지 현재스크롤위치 저장
                                                                                                    CF.setScrollY(window.scrollY);
                                                                                                }}
                                                                                            >
                                                                                                운임정보 등록
                                                                                            </Link>
                                                                                        : null}
                                                                                    </td>
                                                                                    <td>
                                                                                        <Link 
                                                                                            to={`/shipper/online-check/detail/${invoiceList[i].detltrns[idx].de_ip_date}-${invoiceList[i].detltrns[idx].de_ip_no}`} 
                                                                                            className="btn2_s"
                                                                                            onClick={()=>{
                                                                                                //리스트페이지 현재스크롤위치 저장
                                                                                                CF.setScrollY(window.scrollY);
                                                                                            }}
                                                                                        >
                                                                                            {status === 1 || status === 2 ? '수정' : '보기'}
                                                                                        </Link>
                                                                                        {/* {status === 1 || status === 2 ?
                                                                                            <Link 
                                                                                                to={`/shipper/online-check/detail/${invoiceList[i].detltrns[idx].de_ip_date}-${invoiceList[i].detltrns[idx].de_ip_no}`} 
                                                                                                className="btn2_s"
                                                                                                onClick={()=>{
                                                                                                    //리스트페이지 현재스크롤위치 저장
                                                                                                    CF.setScrollY(window.scrollY);
                                                                                                }}
                                                                                            >수정</Link>
                                                                                            :   <button type="button" className="btn2_s"
                                                                                                    onClick={(e) => {
                                                                                                        e.preventDefault();
                                                                                                        let invoiceData = JSON.parse(localStorage.getItem('invoiceData'));
                                                                                                        let productData = JSON.parse(localStorage.getItem('productData'));
                                                                                                        invoiceData = {
                                                                                                            ip_date_online:invoiceList[i].ip_date_online.trim(),
                                                                                                            ip_no_online:invoiceList[i].ip_no_online.trim(),
                                                                                                            ip_s_kind:invoiceList[i].ip_s_kind.trim(),
                                                                                                            ip_kind:invoiceList[i].ip_kind.trim(),
                                                                                                            ip_loca:invoiceList[i].ip_loca.trim(),
                                                                                                        };
                                                                                                        productData = {
                                                                                                            de_date_online:invoiceList[i].detltrns[idx].de_date_online.trim(),
                                                                                                            de_no_online:invoiceList[i].detltrns[idx].de_no_online.trim(),
                                                                                                            de_seq:invoiceList[i].detltrns[idx].de_seq,
                                                                                                            de_seq2:invoiceList[i].detltrns[idx].de_seq2,
                                                                                                        }
                                                                                                        localStorage.setItem("invoiceData", JSON.stringify(invoiceData));
                                                                                                        localStorage.setItem("productData", JSON.stringify(productData));
                                                                                                        dispatch(proDetailPop({
                                                                                                            proDetailPop:true,
                                                                                                        }));
                                                                                                    }}
                                                                                                >
                                                                                                    보기
                                                                                                </button>
                                                                                        } */}
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                        <tr className="total_tr">
                                                                            <td colSpan='3' className="tx_r">합계</td>
                                                                            <td className="tx_r">{CF.MakeIntComma(sumQuantity)}개</td>
                                                                            <td className="tx_r">{CF.MakeIntComma(sumPrice)}원</td>
                                                                            <td></td>
                                                                            <td></td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>)
                                                                : (<div className="none_data"><span>등록된물품이 없습니다.</span></div>)
                                                            } 
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        {/* 조회가 없을때 ▼ */}
                                        {viewPaging === 0 && (
                                            <div className="pagination">
                                                <button className="prev">
                                                    <span>이전 페이지</span>
                                                </button>
                                                <ul className="num_box">
                                                    <li className="on">
                                                        <button>1</button>
                                                    </li>
                                                </ul>
                                                <button className="next">
                                                    <span>다음 페이지</span>
                                                </button>
                                            </div>
                                        )}
                                        {/* 조회가 페이징보다 클때 ▼ */}
                                        {viewPaging > 0 &&
                                            <Pagination 
                                                nowPage={page_no}
                                                totalCnt={viewPaging}
                                                setPerPage={perPage}
                                                moveToPage={moveToPage}
                                            />
                                        }
                                    </form>
                                )}
                            </Formik>

                            
                        </div>
                    </div>
                </div>
            </div>
        }

        {/* 모바일일때 */}
        {isMobile &&
            <div className="page_sub">
                <Formik
                    initialValues={{
                        // ip_status: ipStatus || "",
                    }}
                    onSubmit={submit}
                    validateOnMount={true}
                >
                    {({values, setFieldValue, handleSubmit, handleChange, handleBlur, errors, touched}) => (
                        <form onSubmit={handleSubmit}>
                            <div className="search_box">
                                <ul>
                                    <li>
                                        <p className="txt">출하일자</p>
                                        <div className="date_input">
                                            <InputDatepicker selectedDate={ipDateStart} ChangeHandler={dStartChange} />
                                            <InputDatepicker selectedDate={ipDateEnd} ChangeHandler={dEndChange} />
                                        </div>
                                    </li>
                                    <li>
                                        <p className="txt">상태</p>
                                        <div className="custom_select">
                                            <select 
                                                value={`ip_status_${ipStatus}`}
                                                onChange={(e)=>{
                                                    let value = e.currentTarget.value;
                                                        value = value.replace(/[^0-9]/g,'');
                                                    setIpStatus(value);
                                                }}
                                                style={{ display: 'block' }}
                                            >
                                                <option value="">전체</option>
                                                <option value="ip_status_1">입하</option>
                                                <option value="ip_status_2">입하승인</option>
                                                <option value="ip_status_3">입하미승인</option>
                                            </select>
                                        </div>
                                    </li>
                                </ul>
                                <button className="btn_s2 w_100 tm10" type="submit">조회</button>
                            </div>
                            {dateError && 
                                <div className="alert_txt f_12">출하일자를 선택해주세요.</div>
                            }
                            <div className="tm20">
                                <p className="medium bp20 lp10">검색 결과 : <span className="txt_sky">{totalCount}</span>건</p>
                                {invoiceList.length == 0 && <div className="none_data"><span>데이터가 없습니다.</span></div>}
                                {invoiceList.length > 0 && invoiceList.map((a,i)=>{
                                    let ip_auct_name = invoiceList[i].ip_auct_name;
                                    let ip_auct_date_start = invoiceList[i].ip_auct_date_start;
                                    let ip_auct_date_end = invoiceList[i].ip_auct_date_end;

                                    return(
                                        <div className="bp30" key={i}>
                                            <div className="custom_table2">
                                                <table>
                                                    <colgroup>
                                                        <col style={{ width: "23%" }} />
                                                        <col style={{ width: "27%" }} />
                                                        <col style={{ width: "23%" }} />
                                                        <col style={{ width: "27%" }} />
                                                    </colgroup>
                                                    <tbody>
                                                        <tr>
                                                            <th>등록번호</th>
                                                            <td colSpan="3">
                                                                <span>{`${invoiceList[i].ip_date_online}-${invoiceList[i].ip_no_online}`}</span>
                                                                {invoiceList[i].detltrns.length === 0 &&
                                                                    <Link to={`/shipper/invoice-check/detail/${invoiceList[i].ip_date_online}-${invoiceList[i].ip_no_online}`} className="btn_view lm10"
                                                                        onClick={()=>{
                                                                            //리스트페이지 현재스크롤위치 저장
                                                                            CF.setScrollY(window.scrollY);
                                                                        }}
                                                                    >보기</Link>
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>경매사</th>
                                                            <td colSpan="3">{ip_auct_name !== null && ip_auct_name.trim().length > 0 &&
                                                                <span className="tag">{ip_auct_name}</span>
                                                            }</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="rp0">경매/입찰<br/>시간</th>
                                                            <td colSpan="3">
                                                                {ip_auct_date_start !== null && ip_auct_date_start.trim().length > 0 &&
                                                                    <span>{ip_auct_date_start}
                                                                        {ip_auct_date_end !== null && ip_auct_date_end.trim().length > 0 &&
                                                                            "~"+ip_auct_date_end
                                                                        }
                                                                    </span>
                                                                }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table> 
                                            </div>
                                            {invoiceList[i].detltrns && invoiceList[i].detltrns.length > 0 ? (<>
                                                        {invoiceList[i].detltrns.map((a,idx) => {
                                                            let de_price = invoiceList[i].detltrns[idx].de_quantity * invoiceList[i].detltrns[idx].de_price1;
                                                            de_price =  CF.MakeIntComma(de_price);
                                                            let de_quantity = CF.MakeIntComma(invoiceList[i].detltrns[idx].de_quantity);

                                                            //상태
                                                            let status = invoiceList[i].detltrns[idx].de_status.trim();
                                                                status = enum_de_status[status][0];

                                                            let de_farm_name = CF.objValueTrim(invoiceList[i].detltrns[idx].de_farm_name);

                                                            return(
                                                                <div className="custom_table gray_table t_border2 tm10" key={idx}>
                                                                    <table>
                                                                        <colgroup>
                                                                            <col style={{ width: "23%" }} />
                                                                            <col style={{ width: "27%" }} />
                                                                            <col style={{ width: "23%" }} />
                                                                            <col style={{ width: "27%" }} />
                                                                        </colgroup>
                                                                        <tbody>
                                                                            <tr>
                                                                                <th className="tx_l">생산자</th>
                                                                                <td colSpan="3" className="tx_l">{de_farm_name}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <th className="tx_l">품목</th>
                                                                                <td colSpan="3">
                                                                                    <div className="flex_wrap">
                                                                                        <div className="over_txt rm10"><span>{invoiceList[i].detltrns[idx].gm_name}</span></div>
                                                                                        {status === 1 || status === 2 ?
                                                                                            <Link 
                                                                                                to={`/shipper/online-check/detail/${invoiceList[i].detltrns[idx].de_ip_date}-${invoiceList[i].detltrns[idx].de_ip_no}`} 
                                                                                                className="btn_modify"
                                                                                                onClick={()=>{
                                                                                                    //리스트페이지 현재스크롤위치 저장
                                                                                                    CF.setScrollY(window.scrollY);
                                                                                                }}
                                                                                            >수정</Link>
                                                                                            : <Link 
                                                                                                    to={`/shipper/online-check/detail/${invoiceList[i].detltrns[idx].de_ip_date}-${invoiceList[i].detltrns[idx].de_ip_no}`} 
                                                                                                    className="btn_view"
                                                                                                    onClick={()=>{
                                                                                                        //리스트페이지 현재스크롤위치 저장
                                                                                                        CF.setScrollY(window.scrollY);
                                                                                                    }}
                                                                                                >보기</Link>
                                                                                        }
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <th className="tx_l">상태</th>
                                                                                <td colSpan="3" className="tx_l">{status} 
                                                                                    {invoiceList[i].detltrns[idx].de_status.trim() == 14 ?
                                                                                        <Link 
                                                                                            to={`/shipper/online-check/detail/${invoiceList[i].detltrns[idx].de_ip_date}-${invoiceList[i].detltrns[idx].de_ip_no}`} 
                                                                                            className="btn2_s2 lm10"
                                                                                            onClick={()=>{
                                                                                                //리스트페이지 현재스크롤위치 저장
                                                                                                CF.setScrollY(window.scrollY);
                                                                                            }}
                                                                                        >
                                                                                            운임정보 등록
                                                                                        </Link>
                                                                                    : null}
                                                                                </td>
                                                                                <td>
                                                                                    
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <th className="tx_l">수량</th>
                                                                                <td className="tx_r">{de_quantity}개</td>
                                                                                <th>판매금액</th>
                                                                                <td className="tx_r">{de_price}원</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            )
                                                        })}
                                                    </>)
                                                : (<div className="none_data"><span>등록된물품이 없습니다.</span></div>)
                                            } 
                                        </div>
                                    )
                                })}
                            </div>
                            {/* 조회가 없을때 ▼ */}
                            {viewPaging === 0 && (
                                <div className="pagination">
                                    <button className="prev">
                                        <span>이전 페이지</span>
                                    </button>
                                    <ul className="num_box">
                                        <li className="on">
                                            <button>1</button>
                                        </li>
                                    </ul>
                                    <button className="next">
                                        <span>다음 페이지</span>
                                    </button>
                                </div>
                            )}
                            {/* 조회가 페이징보다 클때 ▼ */}
                            {viewPaging > 0 &&
                                <Pagination 
                                    nowPage={page_no}
                                    totalCnt={viewPaging}
                                    setPerPage={perPage}
                                    moveToPage={moveToPage}
                                />
                            }
                        </form>
                    )}
                </Formik>
            </div>
        }
    </>);
};

export default OnlineCheck;